<div [innerHTML]="safeResource">
</div>